/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { IAriServiceModelAssemblySearch } from './DataServiceEntities.g';
import { getAriAssemblyListAsync } from './DataActionExtension.g';

/**
 * GetModelAssembly Input Action
 */
export class GetModelAssemblyInput implements Msdyn365.IActionInput {
    public brandCode: string;
    public modelId: number;
    constructor(brandCode: string, modelId: number) {
        this.modelId = modelId;
        this.brandCode = brandCode;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `MODEL-${this.brandCode}-${this.modelId}`;
    public getCacheObjectType = () => 'assemblyList';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetModelAssemblyData {
    ariAssemblyData: IAriServiceModelAssemblySearch[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const modelId = args.requestContext.query?.modelId;
    const brandCode = args.requestContext.query?.brandCode;
    if (!modelId || !brandCode) {
        throw Error('Brand code or model missing from URL');
    }
    return new GetModelAssemblyInput(brandCode, parseInt(modelId, 10));
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetModelAssemblyInput, ctx: Msdyn365.IActionContext): Promise<IGetModelAssemblyData> {
    const response = await getAriAssemblyListAsync({ callerContext: ctx }, input.brandCode, input.modelId);
    return { ariAssemblyData: response };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetModelAssemblyData>>action,
    // TODO: Give your data action a unique id
    id: 'GetModelAssembly',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
